// Sponsored offer cards (OGAds, CPAGrip, AdBlueMedia). Switched off 2026-10-17:
// they drew 0.5% and 0.03% click-through and clashed with ad-network reviews.
// Setting this back to true brings back the cards and the /api/featured-offer feed.
export const OFFERS_ENABLED = false;
